import { useQuery } from '@apollo/react-hooks';
import { gql } from 'graphql-tag';

export const GET_REFUNDS_BY_ACCOUNT = gql`
  query GetRefundsByAccount($account_id: Int!, $limit: Int!, $page: String!) {
    getRefundsByAccount(
      input: { account_id: $account_id, page: $page, limit: $limit }
    ) {
      count
      results {
        id
        user {
          formatted_name
        }
        purchase {
          id
          event {
            name
          }
        }
        date
        total
        track_amount
        fees
        createdBy {
          id
          formatted_name
        }
      }
    }
  }
`;

export function useGetRefundsByAccount({
  accountId,
  limit = 5,
  page = '1',
  skip = false,
}) {
  const { data, loading, error } = useQuery(GET_REFUNDS_BY_ACCOUNT, {
    variables: {
      account_id: accountId,
      limit,
      page,
    },
    fetchPolicy: 'no-cache',
    skip: !accountId || skip,
  });
  return { data, loading, error };
}
